import React, { useState } from 'react'

import {
    Button,
    TextField,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
    Divider,
    Box
} from '@mui/material'

import LoadingButton from '@mui/lab/LoadingButton'

import CloseIcon from '@mui/icons-material/Close'

export default function AddBotDialog({ open, handleClose, submit }) {

    const [pageId, setPageId] = useState();

    return (
        <div>
            <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}
                disablePortal
                disableEnforceFocus
                sx={{ position: 'absolute' }}
            >
                <DialogTitle className="group-flexbox">
                    Adicionar Página Messenger
                    <Button sx={{ 'minWidth': '2rem', 'padding': '0' }} onClick={handleClose}>
                        <CloseIcon/>
                    </Button>
                </DialogTitle>
                <Divider/>
                <DialogContent className="add-bot-dialog-content">
                    <TextField
                        size="small"
                        label="ID da página"
                        fullWidth
                        type="text"
                        variant="outlined"
                        value={pageId}
                        onChange={(e) => setPageId(e.target.value)}
                    />
                    <Box className="user-footer">
                        <LoadingButton className="button-created" onClick={handleClose}>
                            Cancelar
                        </LoadingButton>
                        <LoadingButton className="button-created"
                            onClick={() => submit(pageId)}
                            disabled={! pageId }
                        >
                            Salvar
                        </LoadingButton>
                    </Box>
                </DialogContent>
            </Dialog>
        </div>
    );
}
